export enum SmsDashboardTabEnums {
  RPM = 'rpm',
  CCM = 'ccm',
  UNREGISTERED_RPM = 'unregistered_rpm',
  UNREGISTERED_CCM = 'unregistered_ccm',
}
